// @flow
import * as React from 'react';
import { CheckBox as GrommetCheckbox } from 'grommet/components/CheckBox/CheckBox';

const CheckBoxColumn = (props: Object) => {
    const { value, onChange, checked } = props;

    const onChangeHandler = () => {
        onChange(value);
    };

    return (
        <GrommetCheckbox
            name={`checkbox_${value}`}
            id={`checkbox_${value}`}
            onChange={onChangeHandler}
            checked={checked}
            // disabled={disable}
        />
    );
};

export default CheckBoxColumn;
